<template>
  <!-- Scroll-pinned showcase: the tall outer track lets the inner stage stay
       stuck to the viewport while the page scrolls past it. Scroll progress
       drives `--p` (0→1), which slides a 3-slide filmstrip continuously to the
       left. Once the third slide is reached the track ends and the page scroll
       resumes. Text stays fixed over the sliding images. -->
  <section class="ic-home-pot" ref="root">
    <div class="ic-home-pot__stage" ref="stage">
      <div class="ic-home-pot__head">
        <span class="ic-home-pill">
          <svg class="ic-home-pill__icon" width="19" height="17" viewBox="0 0 52 47" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M22.604 9.14227C22.7751 8.71236 23.0602 8.59772 23.716 8.62638C24.8564 8.62638 25.9969 8.71236 27.1089 8.62638C33.068 8.02451 37.9436 5.33045 41.6787 0.630153C41.6787 0.601492 41.7072 0.572832 41.7357 0.544172C42.1349 0.0282861 42.42 -0.0863552 42.8477 0.0569464C43.2753 0.228908 43.4179 0.515512 43.3609 1.14604C43.1328 4.04073 43.5034 6.84944 44.4729 9.60083C45.8129 13.47 48.1224 16.6513 51.3158 19.202C51.4298 19.288 51.5439 19.374 51.6579 19.46C51.9431 19.7179 52.0856 20.0045 51.9431 20.4058C51.8005 20.7784 51.5439 20.9503 51.0877 20.9503C50.546 20.9503 50.0327 20.893 49.491 20.893C42.6766 20.9503 37.1167 23.673 32.8399 29.0039C32.7258 29.1472 32.6403 29.2618 32.5262 29.3765C32.2696 29.6057 31.9845 29.6631 31.6709 29.5198C31.3857 29.4051 31.2147 29.1758 31.1577 28.8319C31.1577 28.6886 31.1577 28.5453 31.1577 28.402C31.5283 21.0363 28.8767 15.0463 23.1742 10.3747C23.0317 10.26 22.8891 10.1454 22.7465 10.0021C22.4899 9.74413 22.4614 9.45753 22.5755 9.14227H22.604Z"/>
            <path d="M2.94233 30.267C3.05638 29.9517 3.31299 29.8657 3.7977 29.8657C4.68158 29.8657 5.56546 29.923 6.44934 29.8657C11.0968 29.4071 14.8889 27.3149 17.7972 23.6464C17.7972 23.6464 17.8257 23.5891 17.8542 23.5604C18.1679 23.1592 18.396 23.0732 18.7096 23.1879C19.0232 23.3025 19.1658 23.5318 19.1088 24.0477C18.9377 26.3118 19.2228 28.49 19.9641 30.6109C21.0191 33.6202 22.7868 36.1137 25.2959 38.0912C25.3814 38.1485 25.467 38.2345 25.5525 38.2918C25.7806 38.4925 25.8662 38.7217 25.7806 39.0084C25.6666 39.295 25.467 39.4383 25.1248 39.4383C24.6972 39.4383 24.298 39.3809 23.8703 39.3809C18.567 39.4383 14.2332 41.5305 10.8972 45.7149C10.8117 45.8295 10.7547 45.9155 10.6406 46.0015C10.441 46.1734 10.2129 46.2308 9.95634 46.1161C9.72824 46.0301 9.58568 45.8295 9.55717 45.6002C9.55717 45.4856 9.55717 45.3709 9.55717 45.2563C9.84229 39.5242 7.78941 34.8526 3.3415 31.2127C3.22746 31.1268 3.1134 31.0408 3.02787 30.9261C2.82828 30.7255 2.79977 30.4962 2.88531 30.2383L2.94233 30.267Z"/>
            <path d="M0.0285117 8.25246C0.114048 8.05184 0.256611 7.99452 0.570245 7.99452C1.14049 7.99452 1.71073 8.02318 2.28098 7.99452C5.27476 7.70792 7.6983 6.36088 9.5801 3.98207C9.5801 3.98207 9.5801 3.95341 9.60862 3.92475C9.8082 3.66681 9.95076 3.60949 10.1789 3.69547C10.3784 3.78145 10.464 3.92475 10.4355 4.24002C10.3214 5.67303 10.521 7.10605 10.9772 8.45309C11.6615 10.3733 12.802 11.9783 14.3987 13.2394C14.4557 13.2967 14.5127 13.3253 14.5697 13.3827C14.7123 13.4973 14.7693 13.6693 14.7123 13.8412C14.6553 14.0418 14.5127 14.1278 14.2846 14.1278C14.028 14.1278 13.7429 14.0992 13.4863 14.0992C10.0648 14.1278 7.29912 15.4749 5.16071 18.1689C5.10368 18.2263 5.07517 18.3122 4.98964 18.3696C4.87559 18.4842 4.70452 18.5129 4.56195 18.4555C4.41939 18.3982 4.33386 18.2836 4.30534 18.1116C4.30534 18.0256 4.30534 17.9683 4.30534 17.8823C4.47642 14.2138 3.16486 11.2045 0.313635 8.88299C0.25661 8.82567 0.171075 8.76835 0.11405 8.71103C1.45516e-06 8.56773 -0.0285127 8.45309 0.0285117 8.28112V8.25246Z"/>
          </svg>
          Immaginala
        </span>
        <h2 class="ic-home-pot__title ic-home-sectitle">Tutte le case hanno un potenziale</h2>
        <p class="ic-home-pot__lead">E un progettista ImmaginaCasa può dimostrartelo.</p>
      </div>
      <div class="ic-home-pot__card">
        <div class="ic-home-pot__strip" ref="strip">
          <div
            v-for="(img, i) in slides"
            :key="i"
            class="ic-home-pot__slide"
            :style="{ backgroundImage: `url(${img})` }"
          ></div>
        </div>
        <!-- Appears centered over the card once the third image has fully
             revealed (see `showCta` in update()). -->
        <transition name="ic-home-pot__cta-fade">
          <div v-if="showCta" class="ic-home-pot__cta-wrap">
            <button type="button" class="ic-home-btn ic-home-pot__cta" @click="goToListings">
              Vai agli annunci
            </button>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePotential',
  data() {
    // Same kitchen across the renovation journey, revealed one wipe at a time.
    // Optimized WebP (scripts/optimize-images.cjs → public/img-opt/): ~1.9 MB of
    // source JPEGs down to ~180 KB. These are decorative CSS backgrounds below
    // the fold, so a single 1200w WebP each is plenty.
    return {
      slides: [
        '/img-opt/potential-1-1200.webp',
        '/img-opt/potential-2-1200.webp',
        '/img-opt/potential-3-1200.webp',
        '/img-opt/potential-4-1200.webp',
      ],
      raf: null,
      showCta: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    // Mobile: la barra URL che collassa/espande cambia l'altezza del viewport
    // dinamico (dvh) senza necessariamente emettere un resize della window —
    // visualViewport lo segnala sempre, così `--p` resta coerente col pin.
    if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onScroll);
    this.update();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onScroll);
    if (this.raf) cancelAnimationFrame(this.raf);
  },
  methods: {
    onScroll() {
      // Coalesce scroll events into one rAF-timed layout read.
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    },
    update() {
      const root = this.$refs.root;
      const strip = this.$refs.strip;
      if (!root || !strip) return;
      const rect = root.getBoundingClientRect();
      // Span di scroll mentre lo stage è pinnato = altezza traccia − altezza
      // stage. Misurare lo stage (100dvh) invece di assumere window.innerHeight
      // tiene il progresso allineato al pin CSS anche quando l'altezza del
      // viewport mobile cambia (barra URL); fallback a innerHeight dove il
      // layout non è disponibile (es. jsdom nei test).
      const stage = this.$refs.stage;
      const stageHeight = (stage && stage.offsetHeight) || window.innerHeight;
      const distance = rect.height - stageHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(distance, 0));
      const p = distance > 0 ? scrolled / distance : 0;
      strip.style.setProperty('--p', p.toFixed(4));

      // Reveal fractions for the three oblique before/after wipes (quarters of p).
      const r1 = Math.min(Math.max(p * 4, 0), 1);
      const r2 = Math.min(Math.max(p * 4 - 1, 0), 1);
      const r3 = Math.min(Math.max(p * 4 - 2, 0), 1);
      strip.style.setProperty('--r1', r1.toFixed(4));
      strip.style.setProperty('--r2', r2.toFixed(4));
      strip.style.setProperty('--r3', r3.toFixed(4));

      // Reveal the CTA once the last image has fully wiped in (r3 === 1),
      // and keep it through the final hold on that image.
      this.showCta = r3 >= 1;
    },
    goToListings() {
      this.$router.push('/annunci');
    },
  },
};
</script>
